export default __webpack_public_path__ + "static/media/class-timetable.42976cc3.jpeg";